export default "__VITE_ASSET__Ct6N8rLL__"